<template>
  <div class="team-page">
    <h1>This is the team page</h1>
  </div>
</template>

<script>
export default {
  name: 'Team'
}
</script>

<style scoped>
</style>
